import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { State } from 'vuex-class';
import api from '@/api/module';
import { IUSERSTATE } from '@/store/state.d';
import { ILOGPRE } from '@/types/base.d';

interface IMenuType {
  label: string,
  value: string,
}

@Component
export default class formMixin extends Vue {
  @State user!: IUSERSTATE

  public log: ILOGPRE = {
    name: '模块管理 - 模态框 - ',
    component: 'set/menu/components/bModal',
  }

  public form: any = {};

  private loading: boolean = false

  public $refs!: {
    form: Form,
  }

  private rules: any = {
    moduleTitle: [
      { required: true, message: '请填写模块名称', trigger: 'change' },
    ],
    modulePath: [
      { required: true, message: '请填写模块地址', trigger: 'change' },
    ],
    moduleSeq: [
      { required: true, message: '请为模块排序', trigger: 'change' },
    ],
  }

  // 重置表单
  resetForm() {
    this.$refs.form.resetFields();
  }

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  // 提交表单
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('添加')) {
        //   let ids: any = this.form.moduleFolder;
        //   if (ids.length === 0) ids = ['-1']; // 如果未选择则为根节点
          api.addMoudle(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.editMoudle(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
